export default function noop() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-composite-projections/node_modules/d3-geo/src/noop.js
// module id = 25
// module chunks = 0